"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XsButton = exports.ExternalLinkButton = exports.TagButton = exports.LinkOffButton = exports.CallApiButton = exports.TextButton = exports.ScenarioButton = exports.SecondaryOutlinedButton = exports.OutlinedButton = exports.ButtonCancelSmall = exports.ButtonCancelLarge = exports.ButtonLarge = exports.ButtonSmall = exports.CreateNewButton = exports.Button = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Button_1 = __importDefault(require("@mui/material/Button"));
var styles_1 = require("@mui/material/styles");
var Launch_1 = __importDefault(require("@mui/icons-material/Launch"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var base_1 = require("@apis/base");
var useEnqueueSnackbar_1 = require("@store/useEnqueueSnackbar");
var grayActiveBgColor = "rgba(57, 84, 108, 0.2)";
var grayHoverBgColor = "rgba(57, 84, 108, 0.05)";
var outlinedHoverBgColor = "rgba(36, 166, 247, 0.16)";
var secondaryOutlinedColor = "#39546C";
var secondaryOutlinedHoverBgColor = "rgba(57, 84, 108, 0.05)";
var scenarioButtonBorderColor = "#032136";
var scenarioButtonActiveBgColor = "rgba(57, 84, 108, 0.2)";
var StyledMButton = (0, styles_1.styled)(Button_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: "1.4rem",
        boxShadow: "none",
        "&:hover": {
            borderColor: "#1A67A0",
            boxShadow: "none",
        },
        "&:active": {
            backgroundColor: theme.palette.primary.light,
            boxShadow: "none",
        },
        "& .MuiButton-startIcon": {
            marginRight: "4px",
        },
        "& .MuiButton-endIcon": {
            marginLeft: "4px",
        },
    });
});
var StyledButton = (0, styles_1.styled)(StyledMButton)(function (_a) {
    var theme = _a.theme;
    return ({
        fontWeight: 600,
        "&:active": {
            backgroundColor: theme.palette.primary.light,
        },
        "&.Mui-disabled": {
            background: "#E7EFF7",
            color: "#ffffff!important",
        },
    });
});
var StyledTagButton = (0, styles_1.styled)(Button_1.default)(function () { return ({
    fontWeight: 600,
    textTransform: "initial",
    backgroundColor: "transparent",
    color: "#39546C",
    fontSize: "10px",
    boxShadow: "none",
    border: "solid rgba(57, 84, 108, 0.4) 1px",
    lineHeight: 1.4,
    minWidth: "44px",
    textAlign: "center",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "fit-content",
    maxWidth: "300px",
    display: "block",
    "&:hover": {
        backgroundColor: "rgba(57, 84, 108, 0.05)",
        border: "solid rgba(57, 84, 108, 0.4) 1px",
        boxShadow: "none",
    },
    "&.active": {
        backgroundColor: "rgba(57, 84, 108, 1)",
        color: "#fff",
        border: "solid rgba(57, 84, 108, 0.4) 1px",
        boxShadow: "none",
    },
    "&:disabled": {
        backgroundColor: "transparent",
        color: "#C0D3DF",
        border: "solid #E7EFF7 1px",
        boxShadow: "none",
    },
}); });
var StyledButtonCancel = (0, styles_1.styled)(StyledMButton)(function (_a) {
    var theme = _a.theme;
    return ({
        fontStyle: "normal",
        fontSize: 14,
        padding: "5px 15px",
        border: "solid 1px rgba(0,0,0, 0)",
        lineHeight: 1.75,
        color: theme.palette.text.secondary,
        "&:hover": {
            background: grayHoverBgColor,
            border: "solid 1px rgba(0,0,0, 0)",
        },
        "&:active, &:focus": {
            background: scenarioButtonActiveBgColor,
            border: "solid 1px rgba(0,0,0, 0)",
        },
    });
});
var StyledButtonLarge = (0, styles_1.styled)(StyledMButton)(function (_a) {
    var theme = _a.theme;
    return ({
        width: "240px",
        maxWidth: "100%",
        fontSize: "2.2rem",
        fontWeight: 500,
        padding: theme.spacing(2, 2.5),
        lineHeight: 1,
        "&.Mui-disabled": {
            color: "#FFF",
            backgroundColor: "#E7EFF7",
        },
    });
});
var StyledButtonCancelLarge = (0, styles_1.styled)(StyledMButton)(function (_a) {
    var theme = _a.theme;
    return ({
        width: "240px",
        color: theme.palette.text.secondary,
        fontSize: "2.2rem",
        fontWeight: 500,
        border: "2px solid rgba(57, 84, 108, 0.4)",
        "&:hover": {
            backgroundColor: grayHoverBgColor,
            border: "2px solid #39546C",
        },
        "&:active": {
            backgroundColor: grayActiveBgColor,
        },
        "&:focus": {
            backgroundColor: grayActiveBgColor,
        },
    });
});
var StyledButtonOutlined = (0, styles_1.styled)(StyledMButton)(function (_a) {
    var theme = _a.theme;
    return ({
        fontWeight: 600,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(0),
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: outlinedHoverBgColor,
        },
        "&:active": {
            backgroundColor: outlinedHoverBgColor,
            color: theme.palette.primary.light,
        },
        "&:focus": {
            backgroundColor: outlinedHoverBgColor,
            color: theme.palette.primary.light,
        },
        "&:disabled": {
            color: "#C0D3DF",
            borderColor: "#E7EFF7",
        },
    });
});
var StyledSecondaryButtonOutlined = (0, styles_1.styled)(StyledButtonOutlined)(function () { return ({
    border: "1px solid rgba(57, 84, 108, 0.4)",
    color: secondaryOutlinedColor,
    "&:hover": {
        backgroundColor: secondaryOutlinedHoverBgColor,
        border: "1px solid rgb(57, 84, 108)",
    },
    "&:active": {
        backgroundColor: secondaryOutlinedHoverBgColor,
        color: secondaryOutlinedColor,
    },
    "&:focus": {
        backgroundColor: secondaryOutlinedHoverBgColor,
        color: secondaryOutlinedColor,
    },
    "&.Mui-disabled": {
        color: "#C0D3DF",
        border: "1px solid #E7EFF7",
    },
}); });
var StyledScenarioButton = (0, styles_1.styled)(StyledMButton)(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.palette.text.secondary,
        borderRadius: "50px",
        padding: "4px 12px",
        border: "solid 1px rgba(57, 84, 108, 0.4)",
        fontSize: "14px",
        "&:hover": {
            background: "rgba(57, 84, 108, 0.05)",
            borderColor: theme.palette.text.secondary,
            border: "1px solid",
        },
        "&:focus": {
            background: scenarioButtonActiveBgColor,
            borderColor: scenarioButtonBorderColor,
            border: "1px solid",
        },
        "&:active": {
            background: scenarioButtonActiveBgColor,
            borderColor: scenarioButtonBorderColor,
            border: "1px solid",
        },
    });
});
var StyledCreateNewButton = (0, styles_1.styled)(StyledMButton)(function () { return ({
    zIndex: 20,
    fontSize: "14px",
    boxShadow: "none",
    "&:hover": {
        color: "#fff",
    },
    "&:active": {
        color: "#fff",
        backgroundColor: "rgb(41, 101, 146)",
    },
    "&:focus": {
        color: "#fff",
        backgroundColor: "rgb(41, 101, 146)",
    },
    "&.Mui-disabled": { background: "#E7EFF7", color: "#fff" },
}); });
var TextMButton = (0, styles_1.styled)(StyledMButton)(function () { return ({
    color: secondaryOutlinedColor,
    boxShadow: "none",
    backgroundColor: "transparent",
    "&:hover": {
        backgroundColor: secondaryOutlinedHoverBgColor,
    },
    "&:active": {
        backgroundColor: "rgba(57, 84, 108, 0.2)",
        color: secondaryOutlinedColor,
    },
    "&:focus": {
        boxShadow: "none",
        backgroundColor: secondaryOutlinedHoverBgColor,
        color: secondaryOutlinedColor,
    },
}); });
var StyledLinkOffButton = (0, styles_1.styled)(StyledButton)(function () { return ({
    color: "#DD468F",
    border: "solid rgba(214, 17, 112, 0.5) 1px",
    fontSize: "10px",
    lineHeight: "12px",
    paddingLeft: 0,
    paddingRight: 0,
    width: "80px",
    textAlign: "center",
    "& .MuiButton-startIcon": {
        marginRight: "2px",
        marginLeft: 0,
    },
    "& .MuiSvgIcon-root": {
        fontSize: "14px!important",
    },
    "&:hover": {
        backgroundColor: "rgba(246, 64, 154, 0.16)",
        borderColor: "rgba(214, 17, 112, 0.5)",
    },
    "&:active": {
        backgroundColor: "rgba(246, 64, 154, 0.16)",
        borderColor: "rgba(214, 17, 112, 0.5)",
    },
}); });
var StyledXsButton = (0, styles_1.styled)(Button_1.default)(function () { return ({
    fontWeight: 500,
    fontSize: "10px",
    height: "24px",
    color: "secondary",
    cursor: "default",
    backgroundColor: "transparent",
    "&:hover": {
        backgroundColor: "transparent",
        border: "solid #39546C66 1px",
        color: "secondary",
    },
}); });
/**
 * 共通のボタンコンポーネント
 */
var Button = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var sx = rest.sx, variant = rest.variant, option = __rest(rest, ["sx", "variant"]);
    return ((0, jsx_runtime_1.jsx)(StyledButton, __assign({ variant: "contained" }, option, { children: children })));
};
exports.Button = Button;
/**
 * 共通の一覧ページの新規作成ボタンコンポーネント
 */
var CreateNewButton = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var sx = rest.sx, variant = rest.variant, option = __rest(rest, ["sx", "variant"]);
    return ((0, jsx_runtime_1.jsx)(StyledCreateNewButton, __assign({ variant: "contained" }, option, { children: children })));
};
exports.CreateNewButton = CreateNewButton;
/**
 * 共通のボタンコンポーネント(Small)
 */
var ButtonSmall = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var sx = rest.sx, size = rest.size, variant = rest.variant, option = __rest(rest, ["sx", "size", "variant"]);
    return ((0, jsx_runtime_1.jsx)(StyledButton, __assign({ size: "small", variant: "contained" }, option, { children: children })));
};
exports.ButtonSmall = ButtonSmall;
/**
 * 共通のボタンコンポーネント(Large)
 */
var ButtonLarge = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var sx = rest.sx, size = rest.size, variant = rest.variant, option = __rest(rest, ["sx", "size", "variant"]);
    return ((0, jsx_runtime_1.jsx)(StyledButtonLarge, __assign({ variant: "contained" }, option, { children: children })));
};
exports.ButtonLarge = ButtonLarge;
/**
 * リッチメッセージキャンセルボタン
 */
var ButtonCancelLarge = function (props) {
    var sx = props.sx, disabled = props.disabled, size = props.size, variant = props.variant, option = __rest(props, ["sx", "disabled", "size", "variant"]);
    return ((0, jsx_runtime_1.jsx)(StyledButtonCancelLarge, __assign({ variant: "outlined" }, option, { children: "\u30AD\u30E3\u30F3\u30BB\u30EB" })));
};
exports.ButtonCancelLarge = ButtonCancelLarge;
/**
 * キャンセルボタン
 */
var ButtonCancelSmall = function (_a) {
    var sx = _a.sx, disabled = _a.disabled, size = _a.size, children = _a.children, option = __rest(_a, ["sx", "disabled", "size", "children"]);
    return ((0, jsx_runtime_1.jsx)(StyledButtonCancel, __assign({ variant: "text" }, option, { children: children })));
};
exports.ButtonCancelSmall = ButtonCancelSmall;
/**
 * アウトラインボタン
 */
var OutlinedButton = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var sx = rest.sx, variant = rest.variant, option = __rest(rest, ["sx", "variant"]);
    return ((0, jsx_runtime_1.jsx)(StyledButtonOutlined, __assign({ variant: "outlined" }, option, { children: children })));
};
exports.OutlinedButton = OutlinedButton;
/**
 * セカンダリーアウトラインボタン
 */
var SecondaryOutlinedButton = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var sx = rest.sx, variant = rest.variant, option = __rest(rest, ["sx", "variant"]);
    return ((0, jsx_runtime_1.jsx)(StyledSecondaryButtonOutlined, __assign({ variant: "outlined" }, option, { children: children })));
};
exports.SecondaryOutlinedButton = SecondaryOutlinedButton;
/**
 * シナリオ設定ボタン
 */
var ScenarioButton = function (_a) {
    var children = _a.children, onClick = _a.onClick, props = __rest(_a, ["children", "onClick"]);
    var sx = props.sx, disabled = props.disabled, size = props.size, variant = props.variant, option = __rest(props, ["sx", "disabled", "size", "variant"]);
    return ((0, jsx_runtime_1.jsx)(StyledScenarioButton, __assign({ onClick: onClick, variant: "outlined" }, option, { children: "\u8A2D\u5B9A\u78BA\u8A8D" })));
};
exports.ScenarioButton = ScenarioButton;
/**
 * 共通のボタンコンポーネント
 * @deprecated resources/js/react/components/commonsのComponentを利用してください。
 */
var TextButton = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var sx = rest.sx, variant = rest.variant, option = __rest(rest, ["sx", "variant"]);
    return ((0, jsx_runtime_1.jsx)(TextMButton, __assign({ variant: "text" }, option, { children: children })));
};
exports.TextButton = TextButton;
/**
 * 新規作成・編集_保存ボタン
 *
 * @return {*}
 */
var CallApiButton = function (_a) {
    var callback = _a.callback, disabled = _a.disabled, children = _a.children;
    var _b = (0, react_1.useState)(false), isCallingApi = _b[0], setIsCallingApi = _b[1];
    var enqueueSnackbar = (0, useEnqueueSnackbar_1.useEnqueueSnackbar)();
    var clickHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsCallingApi(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, callback()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    enqueueSnackbar(base_1.SERVER_ERROR_MESSAGE, { variant: "error" });
                    return [3 /*break*/, 5];
                case 4:
                    setIsCallingApi(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(exports.ButtonLarge, { onClick: clickHandler, disabled: isCallingApi || disabled, style: { fontSize: "20px" }, children: children }) }));
};
exports.CallApiButton = CallApiButton;
/**
 * 連携解除のボタンコンポーネント(Small)
 */
var LinkOffButton = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var sx = rest.sx, size = rest.size, variant = rest.variant, option = __rest(rest, ["sx", "size", "variant"]);
    return ((0, jsx_runtime_1.jsx)(StyledLinkOffButton, __assign({ variant: "outlined" }, option, { children: children })));
};
exports.LinkOffButton = LinkOffButton;
/**
 * タグボタンコンポーネント(Small)
 */
var TagButton = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var sx = rest.sx, size = rest.size, variant = rest.variant, option = __rest(rest, ["sx", "size", "variant"]);
    return ((0, jsx_runtime_1.jsx)(StyledTagButton, __assign({ size: "small", variant: "contained" }, option, { children: children })));
};
exports.TagButton = TagButton;
/**
 * 外部リンクボタン
 */
var ExternalLinkButton = function (_a) {
    var text = _a.text, href = _a.href, _b = _a.isShowLaunchIcon, isShowLaunchIcon = _b === void 0 ? true : _b;
    var clickHandler = function () {
        window.open(href, "_blank");
    };
    return ((0, jsx_runtime_1.jsxs)(Button_1.default, { variant: "text", onClick: clickHandler, color: "primary", sx: {
            padding: "5px 8px",
            borderRadius: "4px",
            cursor: "pointer",
            "&:hover": {
                background: "rgba(36, 166, 247, 0.16)",
            },
            textTransform: "none",
        }, children: [(0, jsx_runtime_1.jsx)("span", { style: {
                    display: "inline-block",
                    verticalAlign: "middle",
                    fontSize: "10px",
                    lineHeight: "14px",
                }, children: text }), isShowLaunchIcon && ((0, jsx_runtime_1.jsx)(Box_1.default, { sx: {
                    display: "inline-block",
                    verticalAlign: "middle",
                    ml: "4px",
                    fontSize: "0",
                }, children: (0, jsx_runtime_1.jsx)(Launch_1.default, { sx: {
                        fontSize: "12px",
                    } }) }))] }));
};
exports.ExternalLinkButton = ExternalLinkButton;
/**
 * XSボタンコンポーネント(xsmall)
 */
var XsButton = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var sx = rest.sx, size = rest.size, variant = rest.variant, option = __rest(rest, ["sx", "size", "variant"]);
    return ((0, jsx_runtime_1.jsx)(StyledXsButton, __assign({ variant: "outlined", color: "secondary" }, option, { children: children })));
};
exports.XsButton = XsButton;
